<script setup>
import { useAppStore } from '@/stores/useAppStore';

const appStore = useAppStore();

const onClose = () => {
  appStore.showModalStylesAddedVisible(false);
};
</script>

<template>
  <AppModal v-model="appStore.isModalStylesAddedVisible" :close="onClose">
    <div class="modal">
      <button class="modal_close" @click="onClose"><span /></button>
      <h3 class="modal--title">
        {{ $t('stylesModal.yourStyleHasBeenAdded') }}
      </h3>
      <span class="modal--description">
        {{ $t('stylesModal.theAddedStyle') }}
      </span>
      <div class="modal--content">
        <AppButton color="primary" @click="onClose">
          {{ $t('app.close') }}
        </AppButton>
      </div>
    </div>
  </AppModal>
</template>

<style lang="scss" scoped>
.modal {
  padding: 19px;

  &--content {
    margin-top: 54px;
    display: grid;

    & > * {
      width: 100%;
    }
  }

  &--title {
    margin-bottom: 0;
  }

  &--description {
    margin-top: 12px;
    display: block;
    width: 100%;
    text-align: center;
    color: #989898;
  }
}
</style>
